export const GetProjectData = (data) => {

    return ({
        type: "get_projectData",
        payload: data,

    })
}